import React from "react";
import { Link } from "react-router-dom";
import swimming from "../../../Assets/Hompage/Swimming/swimming_pool.jpg";
import kidz from "../../../Assets/Hompage/Relaxation/kidz.jpeg";
import playground from "../../../Assets/Hompage/Relaxation/entertainment.jpeg";
import restaurant from "../../../Assets/Hompage/Restaurant/restaurant.jpeg";
const ServiceProvide = () => {
  return (
    <div className="serviceBG lg:py-10 md:py-10 xl:px-10">
      <div className="max-w-screen-xl mx-auto lg:pt-[50px] pt-[100px] md:px-0 px-8 pb-20 ">
        <div className="flex justify-center max-w-screen-2xl mx-auto md:p-10">
          <div className="">
            <div className="flex justify-center md:justify-start">
              <div className="nahid-title-designer">
                <h2
                  data-aos="zoom-in"
                  className="text-[40px] mb-5 text-center md:text-start"
                >
                  Services
                </h2>
                <h1
                  data-aos="zoom-in-up"
                  className="md:text-[40px] lg:text-[48px] text-[25px] font-bold "
                >
                  Matir Maya Eco Resort Provides
                </h1>
              </div>
            </div>
            <p className="pt-10 pb-20 text-justify md:text-start text-[18px]">
              Our resort offers a range of luxurious and comfortable rooms, with
              24/7 room service, buffet dining, a spacious dining hall, as well
              as a designated kids' zone and playground for the little ones to
              enjoy. Guests can also take a refreshing dip in the lake and enjoy
              free WiFi and satellite TV channels in their rooms. In addition,
              we provide a shuttle service for sightseeing and a porch with
              villas for guests to relax and enjoy the scenery.
            </p>
          </div>
        </div>
        <div className="max-w-screen-2xl mx-auto md:p-10 ">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 grid-cols-1 gap-10">
            <div className="hover:-translate-y-6 duration-500">
              <div
                data-aos="zoom-in-up"
                className="md:px-0 p-5 provide-section shadow-md"
              >
                <Link
                  to="/Swimming_Pool"
                  rel="noopener noreferrer"
                  className="hover:no-underline"
                >
                  <img src={swimming} alt="Swimming Pool" className="w-full" />
                  <h1 className="text-[25px] mt-5 text-center overflow-hidden">
                    The Swimming Pool
                  </h1>
                  <p className="text-center">View More</p>
                </Link>
              </div>
            </div>
            <div className="hover:-translate-y-6 duration-500">
              <div
                data-aos="zoom-in-up"
                className="md:px-0 p-5 provide-section shadow-md"
              >
                <Link
                  to="/play-Ground"
                  rel="noopener noreferrer"
                  className="hover:no-underline"
                >
                  <img src={playground} alt="Play Ground" />
                  <h1 className="text-[25px] mt-5 text-center">Play Ground</h1>
                  <p className="hover:no-underline hover:text-[#bb4f32] text-center">
                    View More
                  </p>
                </Link>
              </div>
            </div>
            <div className="hover:-translate-y-6 duration-500">
              <div
                data-aos="zoom-in-up"
                className="md:px-0 p-5 shadow-md provide-section"
              >
                <Link
                  to="/Kids-zone"
                  rel="noopener noreferrer"
                  className="hover:no-underline"
                >
                  <img src={kidz} alt="Kids Zone" />
                  <h1 className="text-[25px] mt-5 text-center">Kids Zone</h1>
                  <p className="hover:no-underline hover:text-[#bb4f32] text-center">
                    View More
                  </p>
                </Link>
              </div>
            </div>
            <div className="hover:-translate-y-6 duration-500">
              <div
                data-aos="zoom-in-up"
                className="md:px-0 p-5 shadow-md provide-section"
              >
                <Link
                  to="/Restaurant"
                  rel="noopener noreferrer"
                  className="hover:no-underline"
                >
                  <img src={restaurant} alt="Restaurents" />
                  <h1 className="text-[25px] mt-5 text-center">Restaurant</h1>
                  <p className="hover:no-underline hover:text-[#bb4f32] text-center">
                    View More
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceProvide;
